import { Routes, Route, Navigate } from "react-router-dom";
import { RequireAnyAuth, RequireWorkspace } from "./lib/auth";
import { Layout } from "./components/Layout";
import { Login } from "./pages/Login";
import { Register } from "./pages/Register";
import { Verify } from "./pages/Verify";
import { CheckIns } from "./pages/CheckIns";
import { Locations } from "./pages/Locations";
import { Settings } from "./pages/Settings";
import { Team } from "./pages/Team";
import { Developers } from "./pages/Developers";
import { Usage } from "./pages/Usage";
import { Billing } from "./pages/Billing";
import { Welcome } from "./pages/Welcome";
import { PlatformOverview } from "./pages/admin/PlatformOverview";
import { Tenants } from "./pages/admin/Tenants";
import { TenantDetail } from "./pages/admin/TenantDetail";
import { PreRegistrations } from "./pages/PreRegistrations";
import { AllSites } from "./pages/AllSites";
import { RootRedirect, WorkspaceSelection } from "./pages/WorkspaceSelection";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/auth/verify" element={<Verify />} />
      <Route path="/workspaces" element={<WorkspaceSelection />} />
      <Route path="/welcome" element={<Welcome />} />
      <Route
        element={
          <RequireWorkspace>
            <Layout />
          </RequireWorkspace>
        }
      >
        <Route path="/w/:slug/all-sites" element={<AllSites />} />
        <Route path="/w/:slug/checkins" element={<CheckIns />} />
        <Route path="/w/:slug/locations" element={<Locations />} />
        <Route path="/w/:slug/expected" element={<PreRegistrations />} />
        <Route path="/w/:slug/usage" element={<Usage />} />
        <Route path="/w/:slug/billing" element={<Billing />} />
        <Route path="/w/:slug/settings" element={<Settings />} />
        <Route path="/w/:slug/team" element={<Team />} />
        <Route path="/w/:slug/developers" element={<Developers />} />
      </Route>
      <Route
        element={
          <RequireAnyAuth>
            <Layout />
          </RequireAnyAuth>
        }
      >
        <Route path="/admin" element={<PlatformOverview />} />
        <Route path="/admin/tenants" element={<Tenants />} />
        <Route path="/admin/tenants/:id" element={<TenantDetail />} />
      </Route>
      <Route path="/" element={<RootRedirect />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
